import * as Scrivito from "scrivito";
import getLanguage from "../../utils/getLanguage";
import PlaceholderOrYoutubeComponent from "../../Components/PlaceholderOrYoutube";

const IntroSectionWidgetComponent = Scrivito.connect(({ widget }) => {
  const lang = getLanguage(widget.obj());
  const ytVideo = widget.get("ytVideo")[0];
  const link = widget.get("linkButton");

  return (
    <div className="row intro-section pt-3">
      <div className="col-12 col-lg-7 order-2 order-lg-1">
        <Scrivito.ContentTag
          content={widget}
          attribute="desc"
          className="desc pb-5"
          tag="span"
        />
        {link && (
          <Scrivito.LinkTag to={link} className="btn btn-primary">
            {link.title() || (lang === "de" ? "Mehr erfahren" : "Learn more")}
          </Scrivito.LinkTag>
        )}
      </div>
      <div className="col-12 col-lg-5 order-1 order-lg-2">
        {ytVideo?.get("videoUrl") && (
          <PlaceholderOrYoutubeComponent
            videoUrl={ytVideo?.get("videoUrl")}
            title={ytVideo?.get("title")}
          />
        )}
        {!ytVideo?.get("videoUrl") && (
          <Scrivito.ImageTag
            content={widget}
            attribute="image"
            className="w-100"
          />
        )}
      </div>
    </div>
  );
});

Scrivito.provideComponent("IntroSectionWidget", IntroSectionWidgetComponent);
